import React, { useState } from 'react'
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom'

// styled
import { Container, ProfileMenuContainer, TabButton } from '../components/styled'

// components
import ScoreHistory from '../components/ScoreHistory'
import MetaTags from '../components/MetaTags'
import UserProfileTab from './UserProfileTab'

// modules
import numberWithCommas from '../modules/number-with-commas'

// context
import { AuthConsumer } from '../auth/AuthContext'

const UserProfile = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const currentTab = location.pathname.split('/')[2] || 'owned'
  const [tab, setTab] = useState(currentTab)

  const changeFilter = (e) => {
    setTab(e)
    navigate(`/profile/${e}`)
  }

  return (
    <>
      <MetaTags title='Sortada.com: User Profile' />
      <AuthConsumer>
        {({ user, userName, userScore }) => (
          <Container className='App'>
            <h1>{userName} ({numberWithCommas(userScore)} pts.)</h1>
            <ProfileMenuContainer>
              <TabButton active={tab !== 'voted' && tab !== 'viewed' && tab !== 'score-history'} onClick={() => changeFilter('owned')}>Owned Posts</TabButton>
              <TabButton active={tab === 'voted'} onClick={() => changeFilter('voted')}>Voted Posts</TabButton>
              <TabButton active={tab === 'viewed'} onClick={() => changeFilter('viewed')}>Viewed Posts</TabButton>
              <TabButton active={tab === 'score-history'} onClick={() => changeFilter('score-history')}>Score History</TabButton>
            </ProfileMenuContainer>
            <Routes>
              <Route path='owned' element={<UserProfileTab view='owned' />} />
              <Route path='voted' element={<UserProfileTab view='voted' />} />
              <Route path='viewed' element={<UserProfileTab view='viewed' />} />
              <Route path='score-history' element={<ScoreHistory />} />
              <Route path='/' element={<Navigate to='/profile/owned' replace />} />
            </Routes>
            <br />
            <hr />
            <br />
          </Container>
        )}
      </AuthConsumer>
    </>
  )
}

export default UserProfile
